import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { useGetProjectQuery, useRemoveMemberMutation } from '~/api/v2/hooks';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

interface RemoveMemberCellProps {
  userId: string;
  unregister: (name: string) => void;
  disabled: boolean;
}

const RemoveMemberCell: FC<RemoveMemberCellProps> = ({ userId, unregister, disabled }) => {
  const dispatch = useAppDispatch();
  const projectId = +useParams().projectid!;
  const { data: projectData } = useGetProjectQuery({ projectId });
  const [removeMember] = useRemoveMemberMutation({
    fixedCacheKey: `remove-member-${projectId}`,
  });
  const userToRemove = projectData?.members.find(({ id }) => id === userId);

  const onDelete = async () => {
    await removeMember({ projectId, user_id: userId });
    unregister(userId);
  };

  return (
    <>
      <CustomButton
        buttonType="outlined"
        label="Remove"
        disabled={disabled}
        onClick={() => {
          dispatch(
            openModal({
              type: ModalTypesEnum.CONFIRM,
              payload: {
                title: `Are you sure you want to remove ${userToRemove?.first_name} ${userToRemove?.last_name} from the project?`,
                onSubmit: onDelete,
                confirmButtonLabel: 'Remove user',
              },
            }),
          );
        }}
      >
        Remove
      </CustomButton>
    </>
  );
};

export default RemoveMemberCell;
